import React, { useEffect, useState } from "react";
import Header from "../sharedFiles/header/header";
import { useDispatch, useSelector } from "react-redux";
import { AddOpprId, logoutUser, selectCart, selectUser } from "../ReduxStore/userReducer";
import { Navigate, useNavigate } from "react-router-dom";
import SunspotLoader from "../sharedFiles/loader/loader";
import { fetchCart, fetchData, fetchItemGroup } from "../ReduxStore/reduxThunk";
import "./dashboard.css";
import { Tooltip } from "@mui/material";
import Footer from "../sharedFiles/footer/footer";
import { resetItemGroup, resetItems } from "../ReduxStore/actions";
import Swal from "sweetalert2";
import axios from "axios";
import { SapConnection } from "../API/API";
import { GetGreeterSection, GetGuestCode, GetSalesPerson } from "../API/Greeter/GreeterThunk";
import { fetchOpprtunity } from "../API/OpportunityServices/OpprThunk";

const Dashboard = () => {
  const userData = useSelector(selectUser);
  const dispatch = useDispatch();
  const databaseName = userData?.DatabaseName;
  const userId = userData?.UserId;
  const jwtToken = userData?.JwtToken;
  const accessLevel = userData?.AccessLevel;
  const SlpCode = userData?.slpCode;
  const ItemGroup = useSelector((state) => state.item.itemGroup);
  const {GetOpportHistory} = useSelector((state) => state.Oppr);
  const cartItems = useSelector(selectCart);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const successMessage = localStorage.getItem("successMessage");
  

  //***********This for show the login success message ***********/
  useEffect(() => {
    if(accessLevel ==='G1'){
      return;
    }
    const fetchData = async () => {
      if (successMessage) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: successMessage,
          showConfirmButton: false,
          timer: 2000,
        });
        try {
          const sapApi = `${SapConnection}${databaseName}`;
          const response = await axios.post(sapApi, null);
        } catch (error) {
          console.error("Error fetching company data:", error);
          // Handle errors gracefully (e.g., display error message to the user)
        } finally {
          localStorage.removeItem("successMessage");
        }
      }
    };

    fetchData(); // Call the function immediately

    // Clean-up function (optional)
    return () => {
      // Code to run when the component unmounts (e.g., clear subscriptions)
    };
  }, [successMessage,accessLevel]);
  //********** This is for all get the itemgroup, item and cart item in intial load ******/
  useEffect(() => {
    if(accessLevel ==='G1'){
      return;
    }
    const fetchData = async () => {
      // if (userData || userData?.DatabaseName) {
      try {
        await Promise.all([
          dispatch(fetchItemGroup(databaseName, jwtToken)),
          // dispatch(fetchItems(databaseName, jwtToken)),
          dispatch(fetchCart(userId, jwtToken)),
        ]);
        setIsLoading(false);
      } catch (error) { }
      // }
    };
    fetchData();
  }, [dispatch, databaseName, userId, jwtToken, userData,accessLevel]);

  //********** This is for all get the itemgroup, item and cart item when trigger a place order button ******/
  const handlePlaceOrder = async () => {
    dispatch(AddOpprId(""));
    // dispatch(GetGuestCode({ slpCode: SlpCode }));
    if (ItemGroup && cartItems) {
      localStorage.removeItem('additionalData');
      localStorage.removeItem('DocEntry');
      navigate("/GetGroupItem");
    } else {
      setIsLoading(true);
      await Promise.all([
        dispatch(fetchItemGroup(databaseName, jwtToken)),
        // ,dispatch(fetchItems(databaseName, jwtToken))
       
        dispatch(fetchCart(userId, jwtToken)),
      ])
        .then(() => {
          setIsLoading(false);
          localStorage.removeItem('additionalData');
          localStorage.removeItem('DocEntry');
          navigate("/GetGroupItem");
        })
        .catch((error) => { });
    }
  };
  //********* This is for a handle a outgoing payment trigger **********/
  const handleOutGoingPayment = async () => {
    navigate("/OutGoingPayment");
  };
  const handleCustomerCreation = async () => {
    navigate("/CustomerCreation");
  };
  const handleAttendance = () => {
    navigate("/MarkAttendance");
  };
  const handleCrm = () => {
    navigate("/Crm");
  };
  const handleGreeter = () => {
    navigate("/Greeter");
    // dispatch(GetSalesPerson({databaseName}))
    // dispatch(GetGreeterSection())
  }
  const handleFollowups = () => {
    //  dispatch(fetchOpprtunity({
    //   databaseName: userData.DatabaseName,
    //   SlpCode: userData.slpCode,
    //   accessLevel: userData.AccessLevel
    // }));
    // dispatch(fetchOpprtunity({databaseName, SlpCode, accessLevel}))
    // if (GetOpportHistory&&GetOpportHistory.data.length>0) {
      navigate("/CustomerFollowups");
    //   setIsLoading(false);
    // }

  };
  const handleSQHistory = () => {
    localStorage.removeItem('additionalData');
    localStorage.removeItem('DocEntry');
    navigate("/SQHistory");
  }
  if (!userData || !userData.UserName) {
    dispatch(logoutUser());
    dispatch(resetItemGroup());
    dispatch(resetItems());
    return <Navigate to="/" />;
  }
  return (
    <div>
      <Header />
      <div className="dashBoardMain">
        <div className="dashImage"></div>
        <div className="dashGradient"></div>
        <div className="dashGallery">
          {accessLevel === 'G1' ? (
            <Tooltip title="Greeter">
              <button className="greeterBtn" onClick={handleGreeter}></button>
            </Tooltip>
          ) : (
            <>
              <Tooltip title="Place a Order">
                <button className="PlaceOrder" onClick={handlePlaceOrder}></button>
              </Tooltip>

              <Tooltip title="OutGoing Payment">
                <button
                  className="OutGoingPaymentBtn"
                  onClick={handleOutGoingPayment}
                ></button>
              </Tooltip>

              <Tooltip title="Customer Creation">
                <button
                  className="CustomerCreationBtn"
                  onClick={handleCustomerCreation}
                ></button>
              </Tooltip>

              <Tooltip title="Attendance Marking">
                <button className="AttendanceBtn" onClick={handleAttendance}></button>
              </Tooltip>

              {/* <Tooltip title="CRM">
      <button className="CrmBtn" onClick={handleCrm}></button>
    </Tooltip> */}

              <Tooltip title="Opportunity">
                <button
                  className="OpportunityBtn"
                  onClick={handleFollowups}
                ></button>
              </Tooltip>

              <Tooltip title="Sales Quatation History">
                <button
                  className="OpportunityBtn SqhistoryBtn"
                  onClick={handleSQHistory}
                ></button>
              </Tooltip>
            </>
          )}

        </div>
      </div>
      {isLoading && (
        <div className="loader position-absolute ">
          <SunspotLoader />
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Dashboard;
